import { Entity, Field } from "typegraph";

@Entity({
	many: "article_playlist_many",
	delete: "article_playlist_one_delete"
})
export class FavoritePlaylist {
	@Field()
	public id: string;

	@Field()
	public articleId: number;

	@Field()
	public name: string;

	@Field()
	public contentType: string;
}

@Entity({ delete: "article_playlist_one_delete" })
export class FavoritePlaylistDelete {
	@Field()
	public articleId: number;
}



// WEBPACK FOOTER //
// ./src/panels/favorites/entities/FavoritePlaylist.ts